import { useEffect, useState } from 'react';

import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

import { useSelector } from 'react-redux';

import { RootState } from '../store';

export const DialogSesionCambiada = () => {

    const { token } = useSelector( ( state: RootState ) => state.auth );

    const [open, setOpen] = useState( false );

    const [sesionCerrada, setSesionCerrada] = useState( false );

    const [nombreUsuario, setNombreUsuario] = useState( '' );

    const handleAceptar = () => {

        if( sesionCerrada ){
            window.location.replace( '/auth/login' );
        }
        else {
            window.location.replace( '/' );
        }

    }

    useEffect(() => {

        const handleStorage = ( event: StorageEvent ) => {

            // key null = localStorage.clear() desde otra pestaña
            if( event.key !== null && event.key !== 'data' ){
                return;
            }

            if( !event.newValue ){

                setSesionCerrada( true );
                setNombreUsuario( '' );
                setOpen( true );

                return;
            }

            const data = JSON.parse( event.newValue );

            if( data?.token && data.token !== token ){

                setSesionCerrada( false );
                setNombreUsuario( `${ data.nombres ?? '' } ${ data.apellidos ?? '' }`.trim() );
                setOpen( true );

            }

        }

        window.addEventListener( 'storage', handleStorage );

        return () => {
            window.removeEventListener( 'storage', handleStorage );
        }

    }, [ token ] );

    return (
        <>
            <Dialog open={ open } onClose={ () => {} } >

                <DialogTitle>
                    { sesionCerrada ? 'La sesión se cerró en otra pestaña' : 'Se inició sesión con otra cuenta' }
                </DialogTitle>

                <DialogContent>

                    <DialogContentText>
                        {
                            sesionCerrada
                            ? 'Por seguridad es necesario volver a iniciar sesión'
                            : `La sesión de este navegador ahora es de ${ nombreUsuario }. Esta pestaña se actualizará con esa cuenta`
                        }
                    </DialogContentText>

                </DialogContent>

                <DialogActions>

                    <Button
                        variant='contained'
                        color='primary'
                        onClick={ handleAceptar }
                    >
                        Aceptar
                    </Button>

                </DialogActions>

            </Dialog>
        </>
    );
}
